import request from '@/utils/request'

let SupplyApi = {
  /*供应商列表*/
   supplyList(data) {
    return request._post('/shop/plus.supply.supply/index', data);
  },
  /*添加供应商*/
  addSupply(data) {
    return request._post('/shop/plus.supply.supply/add', data);
  },
  /*获取供应商数据*/
  getSupply(data) {
    return request._get('/shop/plus.supply.supply/edit', data);
  },
    /*角色列表*/
    roleLists(data) {
      return request._post('/shop/auth.role/index', data);
    },
  /*保存供应商*/
  saveSupply(data) {
    console.log(data)
    return request._post('/shop/plus.supply.supply/edit', data);
  },
  /*删除供应商*/
  delSupply(data) {
    return request._post('/shop/plus.supply.supply/delete', data);
  },
  /*查看商品*/
  seeSupply(data) {
    return request._post('/shop/plus.supply.supply/see', data);
  },

  /*等级列表*/
  gradeLists(data) {
    return request._post('/shop/plus.supply.grade/index', data);
},
gradeListsx(data) {
  return request._post('/shop/plus.supply.grade/indexx', data);
},
/*添加等级*/
addgrade(data) {
    return request._post('/shop/plus.supply.grade/add', data);
},
/*修改等级*/
editGrade(data) {
    return request._post('/shop/plus.supply.grade/edit', data);
},
/*删除等级*/
deletegrade(data) {
    return request._post('/shop/plus.supply.grade/delete', data);
},

  /*保存设置*/
  saveSetting(data) {
    return request._post('/shop/plus.supply.Setting/index', data);
  },
  /*获取设置*/
  getSetting(data) {
    return request._get('/shop/plus.supply.Setting/index', data);
  },
  /*获取设置*/
    getDiySkill(data) {
    return request._post('/shop/plus.supply.supply/getDiyProduct', data);
},
 /* 行业列表 */
 categoryList(data,errorback){
  return request._post('/shop/plus.supply.category/index', data, errorback);
},
/* 添加名片分类 */
addCategory(data, errorback) {
  return request._post('/shop/plus.supply.category/add', data, errorback);
},

editCategory(data, errorback) {
  return request._post('/shop/plus.supply.category/edit', data, errorback);
},
delCategory(data, errorback) {
  return request._post('/shop/plus.supply.category/delete', data, errorback);
},
osedit(data) {
  return request._post('/shop/plus.supply.supply/osedit', data);
},

}
export default SupplyApi;



// WEBPACK FOOTER //
// ./src/api/supply.js